import { render, staticRenderFns } from "./YogaCardAlter.vue?vue&type=template&id=722a9619&scoped=true&"
import script from "./YogaCardAlter.vue?vue&type=script&lang=js&"
export * from "./YogaCardAlter.vue?vue&type=script&lang=js&"
import style0 from "./YogaCardAlter.vue?vue&type=style&index=0&id=722a9619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a9619",
  null
  
)

export default component.exports